import React from 'react';
import { Building } from 'lucide-react';

const PropertySidebar = ({ selectedType, onTypeSelect }) => {
  const propertyTypes = [
    { id: 1, name: 'House', image: 'https://i.postimg.cc/hPsYgDT8/House.jpg' },
    { id: 2, name: 'Studio', image: 'https://i.postimg.cc/BvXkMr8B/studio-vs-1-bedroom-0-1200-jpg.webp' },
    { id: 3, name: 'Apartment', image: 'https://i.postimg.cc/2j4JcF6f/Apartment.jpg' },
    { id: 4, name: 'Mansion', image: 'https://i.postimg.cc/tCqrBKw3/mansions-800x445.png' },
    { id: 5, name: 'Mini Flat', image: 'https://i.postimg.cc/vTMPFkBR/Mini-Flat.jpg' },
    { id: 6, name: 'Bungalow', image: 'https://i.postimg.cc/zfvZ4LQh/Bungalow.jpg' },
    { id: 7, name: 'Bedsitter', image: 'https://i.postimg.cc/cJgkQfj9/bedsitter-265943147.jpg' }
  ];

  return (
    <div className="w-full sm:w-16 sm:hover:w-64 transition-all duration-300 bg-gray-50 rounded-xl shadow-lg p-2 overflow-x-auto sm:overflow-y-auto scrollbar-hide group/sidebar relative z-40">
      <div className="flex sm:block gap-2 sm:space-y-2 min-w-max sm:min-w-0">
        {/* All Properties Option */}
        <div
          onClick={() => onTypeSelect(null)}
          className={`bg-white rounded-xl shadow-sm hover:shadow-md transition-all duration-300 cursor-pointer overflow-hidden group min-w-[132px] sm:min-w-0 ${
            selectedType === null ? 'ring-2 ring-blue-500 shadow-lg' : ''
          }`}
        >
          <div className="p-2.5 flex items-center space-x-2">
            <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-gray-500 to-gray-400 flex items-center justify-center group-hover:scale-110 transition-transform duration-300 flex-shrink-0">
              <Building className="w-4 h-4 text-white" />
            </div>
            <div className="overflow-hidden whitespace-nowrap opacity-100 sm:opacity-0 sm:group-hover/sidebar:opacity-100 transition-opacity duration-300">
              <h3 className={`text-xs font-semibold transition-colors duration-200 ${
                selectedType === null ? 'text-blue-600' : 'text-gray-800 group-hover:text-blue-600'
              }`}>
                All Properties
              </h3>
            </div>
          </div>
        </div>

        {propertyTypes.map((property) => {
          const isSelected = selectedType === property.name;
          return (
            <div
              key={property.id}
              onClick={() => onTypeSelect(property.name)}
              className={`bg-white rounded-xl shadow-sm hover:shadow-md transition-all duration-300 cursor-pointer overflow-hidden group min-w-[132px] sm:min-w-0 ${
                isSelected ? 'ring-2 ring-blue-500 shadow-lg' : ''
              }`}
            >
              <div className="p-2.5 flex items-center space-x-2">
                <div className="w-8 h-8 rounded-lg overflow-hidden group-hover:scale-110 transition-transform duration-300 flex-shrink-0 shadow-md">
                  <img 
                    src={property.image} 
                    alt={property.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="overflow-hidden whitespace-nowrap opacity-100 sm:opacity-0 sm:group-hover/sidebar:opacity-100 transition-opacity duration-300">
                  <h3 className={`text-xs font-semibold transition-colors duration-200 ${
                    isSelected ? 'text-blue-600' : 'text-gray-800 group-hover:text-blue-600'
                  }`}>
                    {property.name}
                  </h3>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PropertySidebar;
